import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";

import BG from "../../../assets/images/go-star-image.png";
import { getGoStarRoute } from "../../../../../routers/routeUtils";

const GoStarCard = () => {
  const { t } = useTranslation("ads", { keyPrefix: "goStarCard" });
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        backgroundImage: `url(${BG})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        width: "100%",
        height: "364px",
        borderRadius: "8px",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-end",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "16px",
          padding: "20px 16px",
          height: "fit-content",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: "4px",
          }}
        >
          <Typography
            sx={{
              color: "var(--White, #FFF)",
              fontFamily: "Montserrat",
              fontSize: "20px",
              fontStyle: "normal",
              fontWeight: 750,
              lineHeight: "normal",
            }}
          >
            {t("scoutForStarTalents")}
          </Typography>
          <Typography
            sx={{
              color: "var(--White, #FFF)",
              fontFamily: "Montserrat",
              fontSize: "12px",
              fontStyle: "normal",
              fontWeight: 500,
              lineHeight: "normal",
            }}
          >
            {t("scoutDescription")}
          </Typography>
        </Box>
        <Button
          variant="secondary-md"
          sx={{
            width: "fit-content",
            background: "#FFF !important",
            border: "1px solid var(--Green---100, #008B07) !important",
          }}
          onClick={() => navigate(getGoStarRoute())}
        >
          {t("getStarted")}
        </Button>
      </Box>
    </Box>
  );
};

export default GoStarCard;
